import { render, staticRenderFns } from "./uom.vue?vue&type=template&id=c20902e4&scoped=true"
import script from "./uom.vue?vue&type=script&lang=js"
export * from "./uom.vue?vue&type=script&lang=js"
import style0 from "./uom.vue?vue&type=style&index=0&id=c20902e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20902e4",
  null
  
)

export default component.exports